import { useState } from "react";
import React from "react";
import BasicTemplateCard from "../../../layout/BasicTemplateCard";
import { Grid } from "@mui/material";
import { successNote, toastErrorNotify } from "../../../helpers/toastNotify";
import { useDeleteTemplateMutation } from "../../../services/Template/templateSlice";
import {getModuleTypeColor, modulePackageName} from "../../../utils/displayUtils";

const TemplateCard = React.memo(({ data, endpoint, label }) => {
  const [templateId, setTemplateId] = useState(null);
  const [deleteUrl, setDeleteUrl] = useState(null);
  const [deleteTemplate] = useDeleteTemplateMutation();

  // Delete operation
  const handleDelete = async () => {
    if (!templateId || !deleteUrl) {
      // handle error when templateId or deleteUrl is not set
      console.error("templateId or deleteUrl is not set");
      console.error("templateId", templateId, "deleteUrl", deleteUrl);

      return;
    }
    try {
      await deleteTemplate({ deleteUrl, templateId }).unwrap();
      successNote("Mal slettet");
    } catch (err) {
      const msg =
        err?.data?.data?.message ??
        err?.data?.message ??
        err?.error ??
        "Mislyktes å slette malen";
      toastErrorNotify(msg);
      console.log("deleteTemplate error", err);
    }
  };

  return (
    <>
        <Grid item key={data.templateId}>
          <BasicTemplateCard
            date={
              data.isDefault
                ? ""
                : new Date(data.creationDateTime)
                    .toLocaleString("no-No")
                    .split(",")[0]
            }
            title={
              data.name.length > 22
                ? data.name.slice(0, 22).charAt(0).toUpperCase() +
                  data.name.slice(0, 22).slice(1) +
                  "..."
                : data.name.charAt(0).toUpperCase() + data.name.slice(1)
            }
            content={`Mal: ${data.trainingIsActive ? "Trening  " : ""}${
              data.testIsActive ? "Test  " : ""
            }${data.theoryIsActive ? "Teori" : ""}`}
            label={modulePackageName(label)}
            labelColor={`${getModuleTypeColor(label)}`}
            subContent={[
              data.trainingIsActive &&
                `Krav til godkjent trening: ${data.generalSuccessPercentage}%`,
              data.testIsActive &&
                `Krav til godkjent test: ${data.testApprovalPercentage}%`,
              data.patientCount && `Antall pasienter: ${data.patientCount}`,
            ]
              .filter(Boolean)
              .join(" \r\n")}
            onMouseOver={() => {
              setTemplateId(data.templateId);
              setDeleteUrl(endpoint);
            }}
            isDefault={data.isDefault}
            onDeleteButtonClick={() => handleDelete()}
          />
        </Grid>
    </>
  );
});

export default TemplateCard;
